/* eslint-disable camelcase */
import { IP150_LENGTH } from './constants.js'

export default {
	validateEmail: function (email) {
		console.debug('validateEmail')

		var re = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/

		if (re.test(email)) {
			if (email.endsWith('@sky.uk') ||
			email.endsWith('@skytv.it') ||
			email.endsWith('@external.skytv.it')) {
				return true
			} else {
				// Show alert or whatever to let people know the email is wrong
				// bootstrap_alert.warning(alert_id, 'Please use your Sky email address or contact your line manager to request access');
				return false
			}
		} else {
			// Show alert or whatever to let people know the email is wrong
			// bootstrap_alert.warning(alert_id, 'Not a valid e-mail address. Please use your Sky email address or contact your line manager to request access');
			return false
		}
	},

	validatePassword: function (password) {
		if (this.debug) console.log('validatePassword')

		var regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})')

		var resultPassword = regex.test(password)
		if (this.debug) console.log('validatePassword resultPassword ' + resultPassword)

		return resultPassword
	},

	shuffleArray: function (originalArray) {
		for (let i = originalArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[originalArray[i], originalArray[j]] = [originalArray[j], originalArray[i]]
		}

		return originalArray
	},

	validateSerialNumber: function (serialNumber) {
		if (serialNumber.length === IP150_LENGTH) {
			const hex = serialNumber.substr(0, 6)
			const dec = serialNumber.substr(6, 10)

			const hexValue = parseInt('0x' + hex)
			const decValue = parseInt(dec)

			const as16 = this.checkSerialPart(hexValue, 16, 6)
			const as10 = this.checkSerialPart(decValue, 10, 10)
			const sx = (parseInt(as16 + as10) % 16)

			console.log('sx: ' + sx)

			const checkSumStr = sx.toString(16)
			const lowerCaseParam = serialNumber.toLowerCase()

			if (lowerCaseParam.substr(16, 1) === checkSumStr) {
				return true
			} else {
				return false
			}
		} else {
			return false
		}
	},

	checkSerialPart: function (number, base, ndig) {
		var check = 0
		var sum = 0
		var pow = 1
		var index = 0
		var res = 0
		var dig = 0
		var multiplicator = 2

		for (; index < ndig; index++) {
			dig = (Math.floor(number / pow) % base)
			pow *= base
			res = parseInt(dig * multiplicator)

			if (res > base) {
				res = 1 + parseInt(res % base)
			}

			sum += res
			multiplicator = multiplicator == 2 ? 1 : 2

			check = parseInt(base - parseInt(sum % base))
			if (check == base) {
				check = 0
			}
		}

		return check
	},

	checkSerialNumberValidity: function (serialNumber) {
		console.log('checkSerialNumberValidity')

		var accumulator = 0

		var currDigit = parseInt(serialNumber[0])

		var multiDigit = currDigit * 2

		if (multiDigit >= 10) {
			multiDigit -= 9
		}

		accumulator += multiDigit

		accumulator += parseInt(serialNumber[1])

		for (var index = 2; index < serialNumber.length - 2; index += 2) {
			multiDigit = parseInt(serialNumber[index]) * 2

			if (multiDigit >= 10) {
				multiDigit -= 9
			}

			accumulator += multiDigit

			accumulator += parseInt(serialNumber[index + 1])
		}

		multiDigit = parseInt(serialNumber[15]) * 2

		if (multiDigit >= 10) {
			multiDigit -= 9
		}

		accumulator += multiDigit

		var result = accumulator % 10

		if (result !== 0) {
			result = 10 - result
		}

		const newSerial = parseInt(serialNumber + result)

		return newSerial
	},

	makeToast (root, title, variant, message) {
		root.toast(message, {
			title: title,
			variant: variant,
			solid: true
		})
	}
}
